import React from 'react'

export default function ErrorPage (props) {
  return (
    <h1>No Encontrado</h1>
  )
}
